import { Component, ElementRef, Input, ViewChild, HostListener  } from '@angular/core';

@Component({
  selector: 'app-image-zoom-container',
  templateUrl: './image-zoom-container.component.html',
  styleUrls: ['./image-zoom-container.component.css']
})

export class ImageZoomContainerComponent {
  @Input() imgPath: any;

  @ViewChild('displayImg') _displayImg!: ElementRef;
  @ViewChild('displayImgContainer') _displayImgContainer!: ElementRef;
  imgPosition: number = 0;
  displayImgWidth:number = 0;

  // UpdateImagePosition(), This Funciton Is Used To Read 'Sliding-Zoom-Box's X-Axis Position 
  // Then Position The Displayed Image Above To Reflect The Highlighted Portion Of The Sliding-Zoom-Box. 
  // NOTE: We multiply The XPosition by four because the displayed image is 4 times larger than the slider image...
  UpdateImagePosition(xPosition: number) {
    // 1 - The 'imgPosition' Represents How Far Left To Move The Displayed Image.
    this.imgPosition = xPosition * -4;
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const containerWidth = this._displayImgContainer.nativeElement.clientWidth;
      this.displayImgWidth = containerWidth*4;   
  }

  // WHEN THE 'DISPLAY-IMAGE' (ZOOMED-IMAGE) LOADS WE WANT THE SIZE OF THE CONTAINER...
  onImageLoad(img: HTMLImageElement) {
    if(img != null || img != undefined){
      const containerWidth = this._displayImgContainer.nativeElement.clientWidth;
      this.displayImgWidth = containerWidth*4;      
    } 
  }
}